import CMX from '../../api';
import {
  PACKAGES_FETCH_START,
  PACKAGES_FETCH_SUCCESS,
  PACKAGES_FETCH_ERROR,
  PACKAGE_CHECKOUT_INIT,
  PACKAGE_PAYMENT_FORM_SUBMIT,
  PACKAGE_PAYMENT_IS_PROCESSING,
  PACKAGE_PAYMENT_SUCCESS,
  PACKAGE_PAYMENT_ERROR,
  PACKAGE_CHECKOUT_ABANDON
} from '../types';
import { CHECKOUT_CONTEXT_LOYALTY_PACKAGES } from './checkout';

export const fetchUserPackages = () => {
  return dispatch => {
    dispatch({ type: PACKAGES_FETCH_START });

    return CMX.get('/loyalty/packages/')
      .then(response => {
        dispatch({
          type: PACKAGES_FETCH_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: PACKAGES_FETCH_ERROR,
          payload: error.message || 'Error al cargar los paquetes'
        });
      });
  };
};

export const packageCheckoutInit = (items) => ({
  type: PACKAGE_CHECKOUT_INIT,
  context: CHECKOUT_CONTEXT_LOYALTY_PACKAGES,
  items
});

export const packageCheckoutAbandon = () => ({
  type: PACKAGE_CHECKOUT_ABANDON
});

export const packagePaymentFormSubmit = (payment) => ({
  type: PACKAGE_PAYMENT_FORM_SUBMIT,
  payment
});

export const packagePaymentPost = (paymentData) => {
  return (dispatch, getState) => {
    dispatch({ type: PACKAGE_PAYMENT_IS_PROCESSING, isLoading: true });

    return CMX.post('loyalty/packages/purchase', paymentData)
      .then(data => {
        dispatch({
          type: PACKAGE_PAYMENT_SUCCESS,
          data
        });
        return data;
      })
      .catch(error => {
        dispatch({
          type: PACKAGE_PAYMENT_ERROR,
          error: error.message || 'Error al procesar el pago'
        });
        throw error;
      });
  };
};